var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatientRegistration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9863 9.89V12.78C22.9863 16.34 22.0963 17.22 18.5463 17.22H7.42633C3.87633 17.22 2.98633 16.33 2.98633 12.78V6.44C2.98633 2.89 3.87633 2 7.42633 2H14.9863",
    stroke: "#D3B474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0348 6.31177C19.0068 6.30777 18.9708 6.30777 18.9388 6.31177C18.2348 6.28777 17.6748 5.71177 17.6748 5.00377C17.6748 4.27977 18.2588 3.69177 18.9868 3.69177C19.7108 3.69177 20.2988 4.27977 20.2988 5.00377C20.2948 5.71177 19.7388 6.28777 19.0348 6.31177Z",
    stroke: "#D3B474",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.682 8.95202C20.97 9.60402 20.026 10 18.986 10C17.946 10 17.002 9.60402 16.29 8.95202C16.33 8.57602 16.57 8.20802 16.998 7.92002C18.094 7.19202 19.886 7.19202 20.974 7.92002C21.402 8.20802 21.642 8.57602 21.682 8.95202Z",
    stroke: "#D3B474",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9863 9.99998C21.1955 9.99998 22.9863 8.20913 22.9863 5.99999C22.9863 3.79086 21.1955 2 18.9863 2C16.7772 2 14.9863 3.79086 14.9863 5.99999C14.9863 8.20913 16.7772 9.99998 18.9863 9.99998Z",
    stroke: "#D3B474",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9863 17.22V22",
    stroke: "#D3B474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98633 13H22.9863",
    stroke: "#D3B474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48633 22H17.4863",
    stroke: "#D3B474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientRegistration);
export default __webpack_public_path__ + "static/media/patient-registration.23e754143524c1701b5b8287153ba473.svg";
export { ForwardRef as ReactComponent };